// Modules
import React, { useEffect } from "react";
// @ts-ignore
import { LocalizationContext } from "react-localize";

// Interfaces
import ResortResult from "Interfaces/ResortResultInterface";
import Item from "Interfaces/ItemInterface";
import FilterResult from "Interfaces/FilterResultInterface";
import SelectedFilters from "Interfaces/SelectedFiltersInterface";
import desc from "../../../../Assests/Img/icon-up.png";
import asc from "../../../../Assests/Img/icon-down.png";


// Components
// @ts-ignore
import sessionStorage from "store/storages/sessionStorage";
import MvToggle from "Generic/MvToggle";
import { MvResortModal } from "Generic/MvModal";
import ResultSingleItem from "./ResultSingleItem";
import MvCheckBox from "Generic/MvCheckBox";
import ResortInfo from "./ResortInfo/ResortInfo";
import FilterResults from "Components/PWAS/Components/SearchResults/FilterResults";
import MvFilterBtn from "Generic/Buttons/MvFilterSortBtn/MvFilterBtn";
import { logAnalyticData, trackAnalyticData } from "Utils/analytics";
import moment from "moment";
import { format } from "path";
import ReservationService from "Services/reservation.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo } from "@fortawesome/free-solid-svg-icons";

type SearchResultsState = {
  showOnlyAvailable: boolean;
  modalPropertyCode: string;
  filteredResorts: undefined[];
  sortChecked: boolean;
  propCode: string;
  resortModal: {
    show: boolean;
    propertyCode: string;
  };
  section1Expanded: boolean;
  section2Expanded: boolean;
  isMobileFilterOpen: boolean;
  isMobile: boolean;
};

type Props = {
  onRemoveItem(propertyCode: string): void;
  results: ResortResult[];
  filters: FilterResult;
  showAvailability(
    propertyCode: any,
    selectedFilters: SelectedFilters,
    waitlistToggleChecked: boolean
  ): void;
  arrangeResults: (sortBy: string) => void;
  toggleFilterGroup(name: string, boolean?: boolean): void;
  selectedFilters: SelectedFilters;
  onFilterSelect(name: string, item: any): void;
  clearFilters(): void;
  pointsSearch?: string;
  forminputt: {
    // Type for forminputt
    numNights: number; // Include numNights property here
    startDate: string;
    resorts: string[];
  };
  constructionMsgdata: null | string;
  onConstructionMsg: () => void;
  isAlternateSearchAvailable: boolean;
  searchedID: any;
  //filterData:any;
};

class SearchResults extends React.Component<Props, SearchResultsState> {
  style = {
    borderBottom: "1px solid #F0F0F0F0",
  };

  constructor(props: Props) {
    super(props);

    this.toggleUnavailable = this.toggleUnavailable.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.showAvailability = this.showAvailability.bind(this);
    this.onSortResults = this.onSortResults.bind(this);
    this.toggleResortModal = this.toggleResortModal.bind(this);
    this.changePropCode = this.changePropCode.bind(this);
    this.getResortInfo = this.getResortInfo.bind(this);
    this.toggleMobileFilter = this.toggleMobileFilter.bind(this);
    this.updateIsMobile = this.updateIsMobile.bind(this);
   
    // this.getfilteredData=this.getfilteredData(this);

    this.state = {
      showOnlyAvailable: false || props.isAlternateSearchAvailable,
      filteredResorts: [],
      modalPropertyCode: "",
      sortChecked: false,
      propCode: "",
      resortModal: {
        show: false,
        propertyCode: "",
      },
      section1Expanded: false,
      section2Expanded: false,
      isMobileFilterOpen: false,
      isMobile: typeof window !== "undefined" ? window.innerWidth <= 750 : false,
    };
    /* logAnalyticData(
      {
        event: "Search Resorts",
        siteSection: "",
        pageName: "Book My Holiday",
        website: "",
      },
      {
        ownerActivity: "Points Reservation",
        step: "1:Search Results",
        errorMessagfe: "",
        notificationType: "",
      }
    );
    trackAnalyticData("points:omnipresent");*/
    const chkSearch = sessionStorage.read("backToSearch");
    if (chkSearch === "alternate") {
      logAnalyticData(
        {
          event: "alternativeSearchResults",
          siteSection: "",
          pageName: "Book My Holiday",
          website: "",
        },
        {
          errorMessagfe: "",
          notificationType: "",
          errorMessage: "",
          resortID: "",
          typeofSearch: "",
          filtersApplied: "", // TODO: Populate the data
          step: "Alternative Search Results Displayed",
          alternativeSearchResorts: this.props.isAlternateSearchAvailable
            ? "yes"
            : "no",
        }
      );
      trackAnalyticData("PAlternative:step2");
    }
    if (chkSearch === "searchResult") {
      // logAnalyticData(
      //   {
      //     event: "Search Resorts",
      //     siteSection: "",
      //     pageName: "Book My Holiday",
      //     website: "",
      //   },
      //   {
      //     errorMessagfe: "",
      //     notificationType: "",
      //     errorMessage: "",
      //     resortID: "",
      //     typeofSearch: "",
      //     filtersApplied: "", // TODO: Populate the data
      //     step: "Step 2: Search Results",
      //     alternativeSearchResorts: this.props.isAlternateSearchAvailable
      //       ? "yes"
      //       : "no",
      //   }
      // );
      // trackAnalyticData("Points:Step2");
      this.logAnalytics();
    }
    if (chkSearch !== "alternate" && chkSearch !== "searchResult") {
      this.logAnalytics();
    }
  }

  componentDidMount(): void {
    this.updateIsMobile();
    window.addEventListener("resize", this.updateIsMobile);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateIsMobile);
  }
  updateIsMobile() {
    const next = window.innerWidth <= 750;
    if (next !== this.state.isMobile) {
      this.setState({ isMobile: next });
      this.setState({ isMobileFilterOpen: false });
      let el: any = document.getElementById("html");
      let box: any = document.getElementById("filter-box");
      box.classList.remove("display");
      el.classList.remove("overflow");
    }
  }
  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<SearchResultsState>,
    snapshot?: any
  ): void {
    if (
      prevProps.isAlternateSearchAvailable !==
      this.props.isAlternateSearchAvailable
    ) {
      this.setState({
        showOnlyAvailable: this.props.isAlternateSearchAvailable,
      });
    }
    if (prevProps.results != this.props.results) {
      const chkSearch = sessionStorage.read("backToSearch");
      // if (chkSearch !== "true") this.logAnalytics();
      sessionStorage.remove("backToSearch");
    }
  }

  logAnalytics() {
    let amountWithResults = 0;
    let filtered = this.props.results
      ? this.filter(this.props.results, this.props.selectedFilters)
      : [];
    let list = this.props.results
      ? this.props.results.filter((resort) => {
          amountWithResults =
            amountWithResults +
            (resort.available[0] &&
            (filtered.indexOf(resort.propertyCode) === -1 ||
              filtered.length === 0)
              ? 1
              : 0);
          return (
            !this.state.showOnlyAvailable ||
            (resort.available[0] &&
              (!this.state.showOnlyAvailable ||
                filtered.indexOf(resort.propertyCode) === -1))
          );
        })
      : [];

    const availableList = list
      .filter((item) => item && item.available && item.available[0])
      .map((r) => r.propertyCode);
    /**
     * PWAS Aanalytics when clicked on omni present search button
     */
    setTimeout(() => {
      const filterData = JSON.parse(
        sessionStorage.read(ReservationService.OPS_FORM_SESSION_KEY) || "{}"
      );
      const checkoutDate = moment(filterData.startDate).add(
        filterData.numNights,
        "days"
      );
      if (this.props.isAlternateSearchAvailable) {
        if (availableList.length === 0) {
          logAnalyticData(
            {
              event: "Search Resorts",
              siteSection: "Points Reservation",
              pageName: "Book My Holiday",
              website: "",
              server: "",
            },
            {
              ownerActivity: "Points Reservation",
              step: "Step 2: Search Results",
              errorMessagfe: "",
              notificationType: "",
              searchedCheckInDate: filterData.startDate,
              searchedActivity: filterData.activity,
              searchedLengthofStay: filterData.numNights,
              inventoryChanged: "",
              searchedCheckOutDate: moment(checkoutDate).format("MM/DD/YYYY"),
              searchedGuestQuantity: filterData.numGuests,
              noResultsReturned: amountWithResults,
              noResortsSearched: filterData.resorts.length,
              typeOfSearch: filterData.searchType ? "True" : "False",
              searchedResorts: filterData.resorts,
              alternativeSearchResorts: "no",
              searchedDestination: "",
              bookingWindow: "",
            }
          );
          trackAnalyticData("points:step2");
          // logAnalyticData(
          //   {
          //     event: "zeroPrimarySearchResults",
          //     pageName: "Book My Holiday",
          //     server: "", // Add actual server name if available
          //     siteSection: "Points Reservation",
          //     website: "VOA",
          //   },
          //   {
          //     searchedResorts: filterData.resorts,
          //     step: "Zero Primary Search Results Message displayed",
          //   }
          // );
          // trackAnalyticData("Zero Primary:step1");
          logAnalyticData(
            {
              event: "zeroAlternativeSearchResults",
              pageName: "Book My Holiday",
              server: "", // Add actual server name if available
              siteSection: "Points Reservation",
              website: "VOA",
            },
            {
              alternativeSearchResorts: "yes",
              searchedResorts: filterData.resorts,
              step: "Zero Alternative Search Results Message displayed",
            }
          );
          trackAnalyticData("Zero Alternative:step3");
        } else {
          logAnalyticData(
            {
              event: "Search Resorts",
              siteSection: "Points Reservation",
              pageName: "Book My Holiday",
              website: "",
              server: "",
            },
            {
              ownerActivity: "Points Reservation",
              step: "Step 2: Search Results",
              errorMessagfe: "",
              notificationType: "",
              searchedCheckInDate: filterData.startDate,
              searchedActivity: filterData.activity,
              searchedLengthofStay: filterData.numNights,
              inventoryChanged: "",
              searchedCheckOutDate: moment(checkoutDate).format("MM/DD/YYYY"),
              searchedGuestQuantity: filterData.numGuests,
              noResultsReturned: 0,
              noResortsSearched: filterData.resorts.length,
              typeOfSearch: filterData.searchType ? "True" : "False",
              searchedResorts: filterData.resorts,
              alternativeSearchResorts: "no",
              searchedDestination: "",
              bookingWindow: "",
            }
          );
          trackAnalyticData("points:step2");
          logAnalyticData(
            {
              event: "alternativeSearchResults",
              siteSection: "Points Reservation",
              pageName: "Book My Holiday",
              website: "",
              server: "",
            },
            {
              ownerActivity: "Points Reservation",
              step: "Alternative Search Results Displayed",
              errorMessagfe: "",
              notificationType: "",
              searchedCheckInDate: filterData.startDate,
              searchedActivity: filterData.activity,
              searchedLengthofStay: filterData.numNights,
              inventoryChanged: "",
              searchedCheckOutDate: moment(checkoutDate).format("MM/DD/YYYY"),
              searchedGuestQuantity: filterData.numGuests,
              noResultsReturned: amountWithResults,
              noResortsSearched: filterData.resorts.length,
              resortReturned: availableList,
              typeOfSearch: filterData.searchType ? "True" : "False",
              searchedResorts: filterData.resorts,
              alternativeSearchResorts: "yes",
              searchedDestination: "",
              bookingWindow: "",
            }
          );
          trackAnalyticData("Alternative:step2");
        }
      } else {
        logAnalyticData(
          {
            event: "Search Resorts",
            siteSection: "Points Reservation",
            pageName: "Book My Holiday",
            website: "",
            server: "",
          },
          {
            ownerActivity: "Points Reservation",
            step: "Step 2: Search Results",
            errorMessagfe: "",
            notificationType: "",
            searchedCheckInDate: filterData.startDate,
            searchedActivity: filterData.activity,
            searchedLengthofStay: filterData.numNights,
            inventoryChanged: "",
            searchedCheckOutDate: moment(checkoutDate).format("MM/DD/YYYY"),
            searchedGuestQuantity: filterData.numGuests,
            noResultsReturned: amountWithResults,
            noResortsSearched: filterData.resorts ? filterData.resorts.length : "0",
            typeOfSearch: filterData.searchType ? "True" : "False",
            searchedResorts: filterData.resorts,
            alternativeSearchResorts: "no",
            searchedDestination: "",
            bookingWindow: "",
          }
        );
        trackAnalyticData("points:step2");
        if (availableList.length === 0) {
        logAnalyticData(
            {
              event: "zeroPrimarySearchResults",
              pageName: "Book My Holiday",
              server: "", // Add actual server name if available
              siteSection: "Points Reservation",
              website: "VOA",
            },
            {
              searchedResorts: filterData.resorts,
              step: "Zero Primary Search Results Message displayed",
            }
          );
          trackAnalyticData("Zero Primary:step1");
        }
      }
    }, 100);
  }

  onSortResults(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ sortChecked: !this.state.sortChecked });
    if (e.target.checked) {
      this.props.arrangeResults("LOCATION");
    } else {
      this.props.arrangeResults("");
    }
  }

  showAvailability(propertyCode: string, waitlistToggleChecked: boolean) {
    this.props.showAvailability(
      propertyCode,
      this.props.selectedFilters,
      waitlistToggleChecked
    );
  }

  filter(resortList: ResortResult[], selectedFilters: SelectedFilters) {
    return resortList
      .filter((resort) => {
        let availableRoomTypes = resort.available
          .flat()
          .map((room) => room.roomType);
        let unAvailableRoomTypes = (resort.unavailable || [])
          .flat()
          .map((room) => room.roomType);
        let activities = resort.activities.map((x) => x.name);
        let hasActivity = selectedFilters["activity"].filters.some(
          (act: any) => {
            return activities.indexOf(act) > -1;
          }
        );
        let hasAvailableRoomType = selectedFilters["roomType"].filters.some(
          (rt: string) => availableRoomTypes.indexOf(rt) > -1
        );
        let hasUnAvailableRoomType = selectedFilters["roomType"].filters.some(
          (rt: string) => unAvailableRoomTypes.indexOf(rt) > -1
        );
        return !(
          (selectedFilters["area"].filters.length === 0 ||
            selectedFilters["area"].filters.indexOf(resort.city) > -1) &&
          (selectedFilters["activity"].filters.length === 0 || hasActivity) &&
          (selectedFilters["roomType"].filters.length === 0 ||
            hasAvailableRoomType)
        );
      })
      .map((resort) => {
        return resort.propertyCode;
      });
  }

  toggleUnavailable() {
    let state = this.state;
    this.setState({
      showOnlyAvailable: !state.showOnlyAvailable,
    });
  }

  removeItem(propertyCode: string) {
    this.props.onRemoveItem(propertyCode);
  }

  toggleMobileFilter() {
    let el: any = document.getElementById("html");
    let box: any = document.getElementById("filter-box");
    if (box) box.classList.toggle("display");
    if (el)  el.classList.toggle("overflow");
    this.setState(
      (prev) => ({ isMobileFilterOpen: !prev.isMobileFilterOpen }),
      () => console.log('isMobileFilterOpen:', this.state.isMobileFilterOpen)
    );
  }

  toggleResortModal(propertyCode: string) {
    this.setState({
      resortModal: {
        propertyCode,
        show: !this.state.resortModal.show,
      },
    });
  }

  changePropCode(propCode: string) {
    this.setState({
      propCode: propCode,
    });
  }

  getResortInfo(propCode: string) {
    this.props.results.filter((pc) => pc.propertyCode === propCode);
  }

  render() {
    const { localize } = this.context;

    let filterLengths =
      this.props.selectedFilters.roomType.filters.length +
      this.props.selectedFilters.views.filters.length +
      this.props.selectedFilters.activity.filters.length +
      this.props.selectedFilters.area.filters.length;
    let filtered = this.props.results
      ? this.filter(this.props.results, this.props.selectedFilters)
      : [];
    let amountWithResults = 0;
    let list = this.props.results
      ? this.props.results
          .filter((resort) => {
            amountWithResults =
              amountWithResults +
              (resort.available[0] &&
              (filtered.indexOf(resort.propertyCode) === -1 ||
                filtered.length === 0)
                ? 1
                : 0);
            return (
              !this.state.showOnlyAvailable ||
              (resort.available[0] &&
                (!this.state.showOnlyAvailable ||
                  filtered.indexOf(resort.propertyCode) === -1))
            );
          })
          .map((results) => {
            return (
              <ResultSingleItem
                key={results.propertyCode}
                onRemoveItem={this.removeItem}
                forminputt={this.props.forminputt}
                constructionMsgdata={this.props.constructionMsgdata}
                onConstructionMsg={this.props.onConstructionMsg}
                openModal={() => this.toggleResortModal(results.propertyCode)}
                result={results}
                isAlternateSearchAvailable={
                  this.props.isAlternateSearchAvailable
                }
                filtered={filtered.indexOf(results.propertyCode) > -1}
                pointsSearch={this.props.pointsSearch}
                showAvailability={(waitlistToggleChecked: boolean) =>
                  this.props.showAvailability(
                    results,
                    this.props.selectedFilters,
                    waitlistToggleChecked
                  )
                }
              />
            );
          })
      : [];

    let filteredTotal = this.props.results
      ? this.props.results.length - filtered.length
      : 0;

    const availableList = list.filter(
      (item) =>
        item.props.result &&
        item.props.result.available &&
        item.props.result.available[0]
    );

    const unavailableList = list.filter(
      (item) =>
        !(
          item.props.result &&
          item.props.result.available &&
          item.props.result.available[0]
        ) && this.props.searchedID.includes(item.props.result.propertyCode)
    );

    const getCleanLocalizedText = (key: string): string => {
      return localize(key)
        .replace(/<p>/g, "")
        .replace(/<\/p>/g, "")
        .replace(/&#39;/g, "'");
    };    

    return (
      <React.Fragment>
        <MvResortModal
          show={this.state.resortModal.show}
          propertyCode={this.state.resortModal.propertyCode}
          toggle={() =>
            this.setState({
              resortModal: {
                ...this.state.resortModal,
                show: !this.state.resortModal.show,
              },
            })
          }
        />

        <div className="search-results row">
          <div className="results-list columns ten">
          <div id="mobile-only-controls">
            <div id="results-availability-status" className="row">
              {this.props.isAlternateSearchAvailable ? (
                <p className="six columns search-status">0 Results Found.</p>
              ) : (
                <p className="six columns search-status">
                  {localize("static.content.we-found")} {amountWithResults}{" "}
                  {localize("static.content.of")} {filteredTotal}{" "}
                  {localize("static.content.resorts-have-availability")}.
                </p>
              )}
              <div className="three columns hide-unavailable desktop-only">
                <MvToggle
                  label={
                    this.state.showOnlyAvailable
                      ? localize("static.content.show-all")
                      : localize("static.content.hide-unavailable")
                  }
                  checked={this.state.showOnlyAvailable}
                  onChange={this.toggleUnavailable}
                  name="n/a"
                  ariaLabel="Toggle between hiding unavailable resorts and showing all"
                  tabIndex={0}
                />
              </div>
              <div className="sort-by-location desktop-only" style={{ marginRight: 30 }}>
                <MvCheckBox
                  label={localize("static.content.sort-by-location")}
                  onChange={this.onSortResults}
                  checked={this.state.sortChecked}
                  id={"sortBy"}
                />
              </div>
            </div>
            {<div className="mobile-only-toggle desktop-only" id="mobile-filter-toggle_3">
                    <MvFilterBtn onClick={this.toggleMobileFilter}  />
            </div>}
            <div className="mobile-controls-row" aria-hidden="true">
              <div className="mobile-toggle">
                <MvToggle
                  label={
                    this.state.showOnlyAvailable
                      ? localize("static.content.show-all")
                      : localize("static.content.hide-unavailable")
                  }
                  checked={this.state.showOnlyAvailable}
                  onChange={this.toggleUnavailable}
                  name="n/a"
                  ariaLabel="Toggle between hiding unavailable resorts and showing all"
                  tabIndex={0}
                />
              </div>
              <div className="mobile-filter" id="mobile-filter-toggle_4">
                    <MvFilterBtn onClick={this.toggleMobileFilter}  />
               </div>     
            </div>

            </div>
            {/* Always show filter toggle */}

              <>
              {unavailableList.length > 0 && (
                  <ul className="result-list-wrapper">                    
                    {unavailableList}
                  </ul>
                )}                                        

                {/* jahia content */}
                {availableList.length > 0 ? (
                  this.props.isAlternateSearchAvailable &&
                  <div className="notification-box">
                    <div className="icon">
                      <FontAwesomeIcon icon={faInfo} />
                    </div>
                    <div className="content">
                      <div className="title">
                        <p>{localize("static.content.similar-results-header")}</p>
                      </div>
                      <div
                        className="description"
                        dangerouslySetInnerHTML={{
                          __html: localize(
                            "static.content.similar-results-description"
                          ),
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="no-result">
                    {/* Palm Tree Illustration */}
                    <div className="hero-image">
                      <img
                        src={localize("Palm-img-error-path")}
                        alt="Palm tree on an island illustration"
                        className="no-results-hero"
                      />
                    </div>

                    {/* Main Header */}
                    <h2 className="no-results-title">
                      {getCleanLocalizedText(
                        "static.content.no-results-header"
                      )}
                    </h2>

                    {/* Description Block */}
                    <div
                      className="no-results-description"
                      dangerouslySetInnerHTML={{
                        __html: localize(
                          "static.content.no-results-description"
                        ),
                      }}
                    />

                    {/* Plan description */}
                    <div
                      className="plan-description"
                      dangerouslySetInnerHTML={{
                        __html: localize(
                          "static.content.no-results-plan-description"
                        ),
                      }}
                    />

                    {/* Expandable section */}
                    <div className="expandable-section">
                      {/* Section 1 */}
                      <button
                        className="expand-btn"
                        onClick={() =>
                          this.setState({
                            section1Expanded: !this.state.section1Expanded,
                          })
                        }
                      >
                        <div
                          className="expand-heading"
                          dangerouslySetInnerHTML={{
                            __html: localize(
                              "static.content.other-ways-to-vacation-header"
                            ),
                          }}
                        />
                        <span className="expand-arrow">
                          {this.state.section1Expanded ? (
                            <img src={desc} alt="collapse icon" />
                          ) : (
                            <img src={asc} alt="collapse icon" />
                          )}
                        </span>
                      </button>
                      {this.state.section1Expanded && (
                        <div className="expanded-content">
                          <div
                            className="expanded-content-one"
                            dangerouslySetInnerHTML={{
                              __html: localize(
                                "static.content.other-ways-to-vacation-description"
                              ),
                            }}
                          />
                        </div>
                      )}

                      {/* Section 2 */}
                      <button
                        className="expand-btn"
                        onClick={() =>
                          this.setState({
                            section2Expanded: !this.state.section2Expanded,
                          })
                        }
                      >
                        <div
                          className="expand-heading"
                          dangerouslySetInnerHTML={{
                            __html: localize(
                              "static.content.search-available-header"
                            ),
                          }}
                        />
                        <span>
                          {this.state.section2Expanded ? (
                            <img src={desc} alt="collapse icon" />
                          ) : (
                            <img src={asc} alt="collapse icon" />
                          )}
                        </span>
                      </button>

                      {this.state.section2Expanded && (
                        <div className="expanded-content">
                          <div
                            className="expanded-content-two"
                            dangerouslySetInnerHTML={{
                              __html: localize(
                                "static.content.search-available-description"
                              ),
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {availableList.length > 0 && (
                  <ul className="result-list-wrapper">                    
                    {availableList}
                  </ul>
                )}                
              </>            
          </div>
          <FilterResults
            isMobileFilterOpen={this.state.isMobileFilterOpen}
            toggleMobileFilter={this.toggleMobileFilter}
            onSortResults={this.onSortResults}
            sortChecked={this.state.sortChecked}
            filters={this.props.filters}
            selectedFilters={this.props.selectedFilters}
            onSelect={this.props.onFilterSelect}
            onClear={this.props.clearFilters}
            toggleOpen={this.props.toggleFilterGroup}
            disableActivitiesFilter={false}
            disableAreaFilter={false}
            disableViewFilter={true}
            disableClearFilter={false}
            disableRoomTypeFilter={false}
            isAlternateSearchAvailable={this.props.isAlternateSearchAvailable}
          />
        </div>
      </React.Fragment>
    );
  }
}

SearchResults.contextType = LocalizationContext;

export default SearchResults;
